import i18n from "@tecma/i18n";

export const currencyFormatter = (
  value: number,
  currency = "EUR",
  options: Intl.NumberFormatOptions = {},
) => {
  return new Intl.NumberFormat(i18n.language || "en-GB", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    ...options,
  }).format(value);
};

export const defaultCurrencyFormatter = (value: number) => {
  return new Intl.NumberFormat(i18n.language || "en-GB", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(value);
};
